export * from "./getValidPatientDestination";
